export default {"src":"/_next/static/media/separate_white.132dbdc1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};